import { CreateGoogleMapsUrls } from './CreateGoogleMapsUrls';

export default function FormatGoogleAutocompleteResult(address) {
    if (!address || !address.address_components) {
        return { line1: '', line2: '' };
    }

    // console.log('Address:', address);

    let streetviewUrl = null;
    let mapUrl = null;

    // Get the relevant urls for the Google Maps info
    if (address.geometry && address.geometry.location) {
        const lat = address.geometry.location.lat();
        const lng = address.geometry.location.lng();
        const urls = CreateGoogleMapsUrls(lat, lng);
        streetviewUrl = urls.streetview;
        mapUrl = urls.map;
    }

    const streetNumber = address.address_components.find(comp => comp.types.includes('street_number'))?.long_name || '';
    const street = address.address_components.find(comp => comp.types.includes('route'))?.long_name || '';
    const city = address.address_components.find(comp => comp.types.includes('locality'))?.long_name || '';
    const state = address.address_components.find(comp => comp.types.includes('administrative_area_level_1'))?.short_name || '';
    const zip = address.address_components.find(comp => comp.types.includes('postal_code'))?.long_name || '';

    const fullAddress = `${streetNumber} ${street}, ${city}, ${state} ${zip}`.trim();

    return {
        line1: `${streetNumber} ${street}`.trim(),
        line2: `${city}, ${state} ${zip}`.trim(),
        fullAddress: fullAddress,
        streetviewUrl: streetviewUrl,
        mapUrl: mapUrl,
        placeId: address.place_id
    };
}